import { useEffect } from "react";
//redux salarycalculationYear2
import {
  getSurplusBeforeTaxYear2,
  getTemplatePayrollTaxYear2,
  getFixedEarnedIncomeYear2,
  getTaxableIncomeYear2,
  getLocalTaxesYear2,
  getStateTaxYear2,
  getPayrollTaxYear2,
  getGeneralPensionYear2,
  getFuneralFeesYear2,
  getReductionOfGeneralPensionYear2,
  getEarnedIncomeTaxYear2,
  getNetProfitPerYearYear2,
  getNetProfitPerMonthYear2,
  getGeneralPayrollTaxYear2,
  getGrossAnnualSalaryYear2,
} from "../Redux/Actions/salarycalculationYear2";

export const CalculationYear2 = (
  dispatch,
  calculating,
  templatePayrollPercent,
  standardTaxRelief,
  localTaxesPercent,
  payrollTaxPercent,
  generalPensionPercent,
  generalPensionCutOffValue,
  funeralFeesPercent,
  earnedIncomeTaxCutOffValue,
  earnedIncomeTaxPercent,
  generalPayrollTaxPercent,
  activeCompany,
  activeYear,
  totalFixedCost,
  totalYearGrossMargin,
  totalMeasuredCostsPerYear,
  nonTaxableIncomeLimit,
  stateTaxCutOfValue,
  stateTaxPercent,
  totalYearGrossMarginPerYear,
  totalFixedCostPerYear,
  salaryCalculationData,
  setCalculating
) => {
  //set companyform for measuresDashboard
  let companyFormYear2 = "";

  salaryCalculationData?.map(
    (item) => (companyFormYear2 = item.object.activeCompany.companyFormYear2)
  );

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      function calculationsYear2() {
        const resultSurplus =
          totalYearGrossMarginPerYear.year2 -
          totalFixedCostPerYear.year2 -
          totalMeasuredCostsPerYear.year2;
        if (resultSurplus === 0) {
          dispatch(getSurplusBeforeTaxYear2(0));
        } else {
          resultSurplus && dispatch(getSurplusBeforeTaxYear2(resultSurplus));
        }

        //get template payroll tax (egenavgifter schablon)
        let resultTemplatePayrollTax =
          (templatePayrollPercent / 100) * resultSurplus;
        if (resultSurplus <= 0) {
          resultTemplatePayrollTax = 0;
          dispatch(getTemplatePayrollTaxYear2(0));
        } else {
          resultTemplatePayrollTax &&
            dispatch(getTemplatePayrollTaxYear2(resultTemplatePayrollTax));
        }
        //#region CompanyForm in "Aktiebolag"
        //get General payroll tax (arbetsgivaravgift)
        let resultGeneralPayrollTax =
          (generalPayrollTaxPercent / 100) * resultSurplus;
        if (resultSurplus <= 0) {
          resultGeneralPayrollTax = 0;
          dispatch(getGeneralPayrollTaxYear2(0));
        } else {
          resultGeneralPayrollTax &&
            dispatch(getGeneralPayrollTaxYear2(resultGeneralPayrollTax));
        }

        //get gross year salary (Årslön brutto)
        let resultGrossAnnualSalary = resultSurplus - resultGeneralPayrollTax;
        if (resultSurplus <= 0) {
          resultGrossAnnualSalary = 0;
          dispatch(getGrossAnnualSalaryYear2(0));
        } else {
          resultGrossAnnualSalary &&
            dispatch(getGrossAnnualSalaryYear2(resultGrossAnnualSalary));
        }

        //get taxBase ("skatteunderlag" (Anders excel)
        let taxBase = resultGrossAnnualSalary + standardTaxRelief;
        if (resultGrossAnnualSalary <= nonTaxableIncomeLimit) {
          taxBase = 0;
        }
        //#endregion CompanyForm in "Aktiebolag"

        //get fixed earned income (fastställd förvärvsinkomst)
        let resultFixedEarnedIncome = resultSurplus - resultTemplatePayrollTax;
        if (resultSurplus <= 0) {
          resultFixedEarnedIncome = 0;
          dispatch(getFixedEarnedIncomeYear2(0));
        } else {
          resultFixedEarnedIncome &&
            dispatch(getFixedEarnedIncomeYear2(resultFixedEarnedIncome));
        }

        //get taxable income (beskattningsbar inkomst)
        let resultTaxableIncome = resultFixedEarnedIncome + standardTaxRelief;
        if (companyFormYear2 === "aktiebolag") {
          resultTaxableIncome = taxBase;
        }
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn. Cut off point salarycalculation stops. else standardtaxRelief is drawn
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultTaxableIncome = 0;
          dispatch(getTaxableIncomeYear2(0));
        } else {
          resultTaxableIncome &&
            dispatch(getTaxableIncomeYear2(resultTaxableIncome));
        }

        //get local taxes (kommunalskatt)
        let resultLocalTaxes = (localTaxesPercent / 100) * resultTaxableIncome;
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultLocalTaxes = 0;
          dispatch(getLocalTaxesYear2(0));
        } else {
          resultLocalTaxes && dispatch(getLocalTaxesYear2(resultLocalTaxes));
        }

        //get state tax (statlig skatt)
        let resultStateTax =
          (stateTaxPercent / 100) * (resultTaxableIncome - stateTaxCutOfValue);
        //if resultStateTax is less than the cut off value no state tax will be drawn.
        if (resultStateTax <= 0) {
          resultStateTax = 0;
          dispatch(getStateTaxYear2(0));
        } else {
          resultStateTax && dispatch(getStateTaxYear2(resultStateTax));
        }
        //egenavgifter
        let resultPayrollTax =
          (payrollTaxPercent / 100) * resultFixedEarnedIncome;
        if (resultPayrollTax === 0) {
          dispatch(getPayrollTaxYear2(0));
        } else {
          resultPayrollTax && dispatch(getPayrollTaxYear2(resultPayrollTax));
        }

        //get general pension (allmän pension)
        let resultGeneralPension =
          (generalPensionPercent / 100) * resultTaxableIncome;
        //if resultGeneralPension is more than the max cut off value max cut off value will be drawn.
        if (resultGeneralPension > generalPensionCutOffValue) {
          resultGeneralPension &&
            dispatch(getGeneralPensionYear2(generalPensionCutOffValue));
          resultGeneralPension = generalPensionCutOffValue;
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultGeneralPension = 0;
          dispatch(getGeneralPensionYear2(0));
        }
        //if resultGeneralPension is between cut off value and nonTaxable limit, pension will be drawn.
        else {
          resultGeneralPension &&
            dispatch(getGeneralPensionYear2(resultGeneralPension));
        }
        //get funeral fees (kyrko och begravningsavgift)
        let resultFuneralFees =
          (funeralFeesPercent / 100) * resultTaxableIncome;
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultFuneralFees = 0;
          dispatch(getFuneralFeesYear2(0));
        } else {
          resultFuneralFees && dispatch(getFuneralFeesYear2(resultFuneralFees));
        }
        //get reduction of general pension(skattereduktion för allmän pension)
        //resultReductionOfGeneralPension mirrors resultGeneralPension and same amount drawn will be returned
        let resultReductionOfGeneralPension = resultGeneralPension;
        if (resultReductionOfGeneralPension > generalPensionCutOffValue) {
          resultReductionOfGeneralPension &&
            dispatch(
              getReductionOfGeneralPensionYear2(generalPensionCutOffValue)
            );
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn or returned.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultReductionOfGeneralPension = 0;
          dispatch(getReductionOfGeneralPensionYear2(0));
        } else {
          resultReductionOfGeneralPension &&
            dispatch(
              getReductionOfGeneralPensionYear2(resultReductionOfGeneralPension)
            );
        }
        //get earned income (jobbskatteavdrag)
        let resultEarnedIncomeTax =
          (earnedIncomeTaxPercent / 100) * resultTaxableIncome;
        //if resultEarnedIncomeTax is more than max cut off value, max cut off value will be returned
        if (resultEarnedIncomeTax > earnedIncomeTaxCutOffValue) {
          resultEarnedIncomeTax &&
            dispatch(getEarnedIncomeTaxYear2(earnedIncomeTaxCutOffValue));
          resultEarnedIncomeTax = earnedIncomeTaxCutOffValue;
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultEarnedIncomeTax = 0;
          dispatch(getEarnedIncomeTaxYear2(0));
        } else {
          //if resultEarnedIncome is less than max cut of value but more than non taxable limit earnedIncometax will be returned.
          resultEarnedIncomeTax &&
            dispatch(getEarnedIncomeTaxYear2(resultEarnedIncomeTax));
        }

        if (companyFormYear2 === "enskildFirma") {
          let resultNetProfitPerYear =
            resultSurplus -
            resultLocalTaxes -
            resultStateTax -
            resultPayrollTax -
            resultGeneralPension -
            resultFuneralFees +
            resultReductionOfGeneralPension +
            resultEarnedIncomeTax;
          if (resultNetProfitPerYear === 0) {
            dispatch(getNetProfitPerYearYear2(0));
          }
          // if resultFixedEarnedIncome is less than the nontaxable limit no tax will be drawn but resultpayrolltax is always drawn
          else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
            resultNetProfitPerYear = resultFixedEarnedIncome - resultPayrollTax;
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear2(resultNetProfitPerYear));
          } else {
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear2(resultNetProfitPerYear));
          }

          //get net profit per month(månadslön netto)
          const resultNetProfitPerMonth = resultNetProfitPerYear / 12;
          if (resultNetProfitPerMonth === 0) {
            dispatch(getNetProfitPerMonthYear2(0));
          } else {
            resultNetProfitPerMonth &&
              dispatch(getNetProfitPerMonthYear2(resultNetProfitPerMonth));
          }
        } else if (companyFormYear2 === "aktiebolag") {
          let resultNetProfitPerYear =
            taxBase -
            resultLocalTaxes -
            resultGeneralPension -
            resultFuneralFees +
            resultReductionOfGeneralPension +
            resultEarnedIncomeTax -
            resultStateTax;
          if (resultNetProfitPerYear === 0) {
            dispatch(getNetProfitPerYearYear2(0));
          } else if (taxBase <= nonTaxableIncomeLimit) {
            resultNetProfitPerYear = resultGrossAnnualSalary;
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear2(resultGrossAnnualSalary));
          } else {
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear2(resultNetProfitPerYear));
          }
          //get net profit per month(månadslön netto)
          const resultNetProfitPerMonth = resultNetProfitPerYear / 12;
          if (resultNetProfitPerMonth === 0) {
            dispatch(getNetProfitPerMonthYear2(0));
          } else {
            resultNetProfitPerMonth &&
              dispatch(getNetProfitPerMonthYear2(resultNetProfitPerMonth));
          }
        }
      }
      calculationsYear2();
      //give time for calculations() to calculate usong calculating hook
      const delay = setTimeout(() => {
        setCalculating(true);
      }, 700);
      return () => clearTimeout(delay);
    }
    return () => {
      isMounted = false;
    };
  }, [
    dispatch,
    calculating,
    templatePayrollPercent,
    standardTaxRelief,
    localTaxesPercent,
    payrollTaxPercent,
    generalPensionPercent,
    generalPensionCutOffValue,
    funeralFeesPercent,
    earnedIncomeTaxCutOffValue,
    earnedIncomeTaxPercent,
    generalPayrollTaxPercent,
    activeCompany,
    activeYear.year,
    totalFixedCost,
    totalYearGrossMargin,
    totalMeasuredCostsPerYear,
    nonTaxableIncomeLimit,
    stateTaxCutOfValue,
    stateTaxPercent,
    totalYearGrossMarginPerYear.year2,
    totalFixedCostPerYear.year2,
    salaryCalculationData,
    companyFormYear2,
    setCalculating,
  ]);
};
